export const HINDI = {
  'language': 'Hindi',
  'amount': {
    'placeholder': 'आप कितना धन जुटाना चाहते हैं?',
    'error': {
      'min': 'न्यूनतम लक्ष्य राशि ₹ 2000 है!',
      'max': 'अधिकतम लक्ष्य राशि ₹ 5 करोड़ हो सकती है',
      'required': 'न्यूनतम लक्ष्य राशि ₹ 2000 है!'
    },
    'hint': 'न्यूनतम ₹ 2000 होना चाहिए',
    'popover': {
      'title': 'लक्ष्य',
      // tslint:disable-next-line:max-line-length
      'desc': `आप अपनी लक्ष्य राशि को बाद में बदल सकते हैं। यदि आप सुनिश्चित नहीं हैं कि कहां से शुरू करना है, तो अधिकांश अभियानों में ₹ 1,00,000 का एक लक्ष्य है।`,
      'eg': 'लक्ष्य ₹ 2000 से बड़ा होना चाहिए'
    }
  },
  'title': {
    'placeholder': 'फंडरेसर का शीर्षक',
    'error': {
      'minlength': 'फंडरेसर शीर्षक 5-75 अक्षरों के बीच होना चाहिए',
      'maxlength': 'फंडरेसर शीर्षक 5-75 अक्षरों के बीच होना चाहिए',
      'required': 'फंडरेसर शीर्षक 5-75 अक्षरों के बीच होना चाहिए'
    },
    'popover': {
      'title': 'यह आपके फंडरेसर का शीर्षक ह',
      'desc': 'जैसे कम उम्र की बालिकाओं को सशक्त बनाने में हमारी मदद करें या हमारी आस्था को कैंसर से लड़ने में मदद करें!'
    },
  },
  'relation': {
    'placeholder': 'आप किसके लिए धन जुटा रहे हैं?',
    'popover': {
      'title': 'आप किसके लिए फंड जुटा रहे हैं',
      'desc': 'आप पर्सनल, क्रिएटिव या एनजीओ के लिए अभियान बना सकते हैं'
    },
    'error': {
      'required': 'कृपया एक वैध विकल्प चुनें'
    }
  },
  'name': {
    'placeholder': `मरीज का पूरा नाम`,
    'error': {
      'maxlength': 'नाम 50 अक्षरों से अधिक नहीं होना चाहिए',
      'pattern': 'कृपया कोई मान्य नाम दर्ज करें',
      'required': 'कृपया कोई मान्य नाम दर्ज करें'
    },
    'hint': 'मरीज के आधार कार्ड में लिखित नाम',
    'popover': {
      'title': `मरीज का नाम`,
      'desc': 'कृपया उनके आधार कार्ड में उल्लिखित रोगी का पूरा नाम दर्ज करें'
    }
  },
  'patient': {
    'placeholder': `मरीज का पूरा नाम`,
    'error': {
      'maxlength': 'नाम 50 अक्षरों से अधिक नहीं होना चाहिए',
      'minlength': 'कृपया उनके आधार कार्ड में उल्लिखित रोगी का पूरा नाम दर्ज करें',
      'pattern': 'कृपया कोई मान्य नाम दर्ज करें',
      'required': 'कृपया कोई मान्य नाम दर्ज करें'
    },
    'hint': 'मरीज के आधार कार्ड में लिखित नाम',
    'popover': {
      'title': `मरीज का नाम`,
      'desc': 'कृपया उनके आधार कार्ड में उल्लिखित रोगी का पूरा नाम दर्ज करें'
    }
  },
  'age': {
    'placeholder': `मरीज की उम्र`,
    'error': {
      'required': 'कृपया एक मान्य आयु समूह दर्ज करें'
    }
  },
  'hosptialisationStatus': {
    'placeholder': `अस्पताल में भर्ती होने की स्थिति`,
    'error': {
      'required': 'जवाब आवश्यक है'
    }
  },
  'cause': {
    'placeholder': 'कृपया उद्देश्य चुनें',
    'popover': {
      'title': 'यह आपका कारण है',
      'desc': 'यह समान विचारधारा वाले लोगों की मदद करने के लिए है, दयालु लोग हमारी वेबसाइट पर आपका फंडराइज़र ढूंढते हैं।'
    },
    'error': {
      'required': 'कृपया उद्देश्य चुनें'
    }
  },
  'end_date': {
    'placeholder': 'अंतिम तिथि',
    'error': {
      'minlength': 'फंडरेसर अंतिम तिथि आज से पुरानी नहीं हो सकती है!',
    },
    'popover': {
      'title': 'फंडरेसर अंतिम तिथि',
      'desc': 'आपका फंडरेसर इस तारीख को समाप्त हो जाएगा।'
    }
  },
  'fundraiser_image': {
    'placeholder': 'चित्र / वीडियो जोड़ें',
    'optional': '(वैकल्पिक)',
    'upload': 'अपलोड करें',
    'popover': {
      'title': 'चित्र अपलोड करें।',
      'desc': `यह आपके फंडरेसर का पहला पृष्ठ है। तस्वीरें आपको अधिक धन जुटाने में मदद करेंगी। ऐसे स्पष्ट चित्र / वीडियो अपलोड करें, जो आपके फंडरेसर का सबसे अच्छा वर्णन करते हैं।`,
      'eg': ` आदर्श आकार: 750x435 px। यदि चित्र बड़ा है, तो चिंता न करें, अपलोड करते समय आप इसे छोटा कर सकते हैं।`
    }
  },
  'beneficiary_image': {
    'placeholder': `Add Patient's Image`,
    'popover': {
      'title': 'This is the person whom you are raising money for.',
      'desc': `Adding an image increase contributions by 50%.
                 We may request additional information from you to verify that the funds raised will go to this beneficiary.`
    }
  },
  'short_description': {
    'placeholder': 'वर्णन करें',
    'error': {
      'minlength': 'न्यूनतम 10 अक्षर आवश्यक है',
      'maxlength': 'वर्णन में 120 से अधिक अक्षर नहीं होने चाहिए'
    },
    'popover': {
      'title': 'Explain your fundraiser in short',
      'desc': `Write a short blurb for your fundraiser in 120 characters.`,
      'eg': `E.g. Aastha is only 8 years old, support her fight against Acute Lymphoblastic Leukemia`
    }
  },
  'description_story': {
    'placeholder':
      'एक कहानी लिखें जो आपके कारण के साथ न्याय करती है और समर्थक को दान बटन पर क्लिक करती है।'
      + '\n\nइन सुझावों का पालन करें-'
      + '\n* इस बारे में बताएँ कि आप किसके लिए धन जुटा रहे हैं।'
      + '\n* अपने समर्थकों को बताएं कि आपने किस कारण के लिए फंडरेसर शुरू किया है ताकि वे योगदान करने के लिए प्रेरित हों।'
      + '\n* अपने समर्थकों से एक अपील करें।',
    'popover': {
      'title': 'हमें अपने फंडरेसर के बारे में अधिक बताएं',
      'desc': 'अपनी कहानी बताएं',
      'placeholder':
        `<div class="hindi14 mb-4">अपने फंडरेसर के संदर्भ का वर्णन करें ताकि आपको समर्थन मिले।</div>
            <div class="hindi14 mb-4">इन सुझावों का पालन करें-</div>
            <div class="hindi14 mb-4">इस बारे में बताएँ कि आप किसके लिए धन जुटा रहे हैं। अपने समर्थकों से एक अपील करें।</div>
            <div class="hindi14 mb-4">अपने समर्थकों से निवेदन करें।</div>
            <div class="hindi14 mb-4">अपने समर्थकों को बताएं कि आपने किस कारण के लिए फंडरेसर शुरू किया है ताकि वे योगदान करने के लिए प्रेरित हों।</div>
            <div class="hindi14 mb-4">अपने समर्थकों को पूरी जानकारी दें कि उनके योगदान का उपयोग कैसे किया जाएगा।</div>`,
    }
  },
  'disease': {
    'label': 'बीमारी',
    'placeholder': 'यहां बीमारी का नाम लिखें',
    'error': {
      'required': 'कृपया एक बीमारी का चयन करें'
    }
  },
  'hospital': {
    'label': 'अस्पताल',
    'placeholder': 'यहां अस्पताल का नाम लिख',
    'error': {
      'required': 'कृपया एक अस्पताल चुनें'
    }
  },
'cover_image': {
  'title': 'कवर इमेज अपलोड करें',
  'desc': `<ul>
    <li>यह आपके फंडरेज़र का चेहरा होगा। अच्छी तस्वीरें आपके फंडरेज़र को अधिक पैसा जुटाने में मदद करेंगी।</li>
    <li>अपने फंडरेज़र का सर्वोत्तम वर्णन करने वाली बिना पिक्सेल वाली, उच्च गुणवत्ता वाली, स्पष्ट तस्वीरें/वीडियो जोड़ें।</li>
    <li>आदर्श आकार: 750x435। यदि इससे बड़ा है, तो चिंता न करें, आप अपलोड करते समय इसे क्रॉप कर सकते हैं।</li>
    <li>सरकारी नियमों और प्लेटफ़ॉर्म अनुपालन के अनुसार बच्चों की तस्वीरों को धुंधला कर दिया जाएगा।</li>
  </ul>`,
  'see_egs': 'उदाहरण देखें'
},
  'medicalPopoverContent': {
    'title': 'दस्तावेज़ (दस्तावेज़ों) पर निम्नलिखित जानकारी स्पष्ट रूप से पठनीय होनी चाहिए:',
    'desc': `
        <ol>
            <li>कुल उपचार लागत, मरीज़ का नाम, अस्पताल का नाम, चिकित्सक का नाम, चिकित्सक परिस्थिति, पत्र की तिथि</li>
            <li>दस्तावेज़ (दस्तावेज़ों) पर लिखी जानकारी अनुदान संचय में साझा की गई जानकारी से मेल खानी चाहिए।</li>
            <li>दस्तावेज़ (दस्तावेज़ों) पर लिखा गया उपचार लागत अनुदान संचय में दर्ज लक्ष्य राशि से मेल खाना चाहिए।</li>
            <li>दस्तावेज़ अपलोड की तारीख से 6 महीने से अधिक पुराना नहीं होना चाहिए</li>
            <li>यदि दस्तावेज़ हस्तलिखित है, तो उस पर डॉक्टर/अस्पताल की मुहर होनी चाहिए </li>
        </ol>`,
    'see_egs': '',
    'hint_medical_file': '*कृपया सुनिश्चित करें कि आपके अपलोड किए गए दस्तावेज़ों में उपचार लागत आसान अनुमोदन के लिए अनुदान संचय लक्ष्य राशि के अनुरूप हो। जमा करने से पहले सभी दस्तावेजों की जांच कर ले। '
  },
  'sample_images': {
    'title': 'इन उदाहरणों का पालन करें',
    'got_it': 'ठीक'
  },
  'guardian_relations': {
    'Friend': {
      'Below 5 years': 'अभिभावक मोबाइल नंबर',
      '6 -10 years': 'अभिभावक मोबाइल नंबर',
      '11 - 17 years': 'अभिभावक मोबाइल नंबर',
      '18 - 30 years': 'मरीज का मोबाइल नंबर',
      '30 - 40 years': 'मरीज का मोबाइल नंबर',
      'Above 40 years': 'मरीज का मोबाइल नंबर'
    },
    'Friend\'s Family': {
      'Below 5 years': 'अभिभावक मोबाइल नंबर',
      '6 -10 years': 'अभिभावक मोबाइल नंबर',
      '11 - 17 years': 'अभिभावक मोबाइल नंबर',
      '18 - 30 years': 'मरीज का मोबाइल नंबर',
      '30 - 40 years': 'मरीज का मोबाइल नंबर',
      'Above 40 years': 'मरीज का मोबाइल नंबर'
    },
    'Colleague': {
      'Below 5 years': 'अभिभावक मोबाइल नंबर',
      '6 -10 years': 'अभिभावक मोबाइल नंबर',
      '11 - 17 years': 'अभिभावक मोबाइल नंबर',
      '18 - 30 years': 'मरीज का मोबाइल नंबर',
      '30 - 40 years': 'मरीज का मोबाइल नंबर',
      'Above 40 years': 'मरीज का मोबाइल नंबर'
    },
    'Relative': {
      'Below 5 years': 'अभिभावक मोबाइल नंबर',
      '6 -10 years': 'अभिभावक मोबाइल नंबर',
      '11 - 17 years': 'अभिभावक मोबाइल नंबर',
      '18 - 30 years': 'मरीज का मोबाइल नंबर',
      '30 - 40 years': 'मरीज का मोबाइल नंबर',
      'Above 40 years': 'मरीज का मोबाइल नंबर'
    },
    'Legal ward': {
      '18 - 30 years': 'मरीज का मोबाइल नंबर',
      '30 - 40 years': 'मरीज का मोबाइल नंबर',
      'Above 40 years': 'मरीज का मोबाइल नंबर'
    }
  },
  'survey': {
    'placeholder': 'आपने पहली बार केटो के बारे में कैसे सुना?',
    'error': {
      'required': 'जवाब आवश्यक है'
    }
  },
  change_easily: 'आप किसी भी समय अपने फंडरेसर में आसानी से बदलाव कर सकते हैं',
  tell_us_more: 'हमें अपने फंडरेसर के बारे में अधिक बताएं',
  patientIsMy: 'मरीज कौन है?',
  qualification: 'आपकी शिक्षा योग्यता',
  occupation: 'आपकी रोजगार स्थिति',
  raising_funds_for: 'उद्देश्य के लिए धन जुटाना',
  ngo_charity: 'एनजीओ/दान पुण्य',
  other: 'अन्य',
  purposeText: 'प्रयोजन',
  change_purpose: 'उद्देश्य बदले',
  save_and_continue: 'सहेजें और जारी रखें',
  ketto_zero_fee: 'केटो प्लेटफ़ॉर्म की शून्य शुल्क नीति आपके लिए अधिक धन सुनिश्चित करती है',
  is_patient_admitted: `क्या मरीज अस्पताल में भर्ती है?`,
  tell_us_about_patient: `हमें मरीज के बारे में बताएं`,
  guardian_no: `अभिभावक मोबाइल नंबर`,
  patient_no: 'मरीज का मोबाइल नंबर',
  yes: `हाँ`,
  no: `नहीं`,
  story_form_title: `आप फंडरेसर क्यों चला रहे हैं? इस बारे में बताएं`,
  help_me_write_this: `लिखने में मदद करें`,
  terms_of_use: `उपयोग की शर्तें`,
  privacy_policy: `गोपनीयता नीति`,
  plans_and_pricing: `मूल्य निर्धारण`,
  submit: 'सबमिट करें',
  get_assistance: 'सहायता प्राप्त करें',
  selectOption: 'कृपया एक विकल्प चुनें',
  validPhNo: 'कृपया एक सही मोबाइल नंबर दर्ज करें',
  back: 'पीछे',
  fieldRequired: 'जवाब आवश्यक है',
  medicalDocTitle: 'दस्तावेज़ जोड़ें',
  acknowledge: `मैं स्वीकार और पुष्टि करता हूं कि ऊपर दी गई जानकारी मेरे ज्ञान और विश्वास से सही है| यदि उपरोक्त जानकारी में से कोई भी गलत पाया जाता है तो मैं उत्तरदायी होने के लिए सहमत हूं । मैं इसे नियामक अधिकारियों के साथ साझा करने या इसका खुलासा करने के लिए अनुमति
    देता हूं, जैसा कि कानून द्वारा आवश्यक हो सकता है।`,
  city: {
    placeholder: 'अपने शहर का नाम लिखें',
    popover: {
      title: 'अपना फंडरेसर शहर दर्ज करें',
      desc: 'यह वह शहर है जिसमें यह फंडरेसर चलेगा'
    }
  },
  'uploadImg': {
    'error': {
      'required': 'जवाब आवश्यक है',
      'pattern': 'कृपया एक सही नंबर दर्ज करें'
    }
  },
  skipStepInfo: 'चिंता मत कीजिए! आप अभी इस कदम को छोड़ कर सबमिट करने के बाद भी कहानी और मेडिकल कागज़ात लगा सकते हैं'
};
